
<div *ngIf="data.length" class="gallery-container">
  <app-creative-gallery-card *ngFor="let card of data" [cardData]="card" (click)="openCardModal(card.id)"></app-creative-gallery-card>
</div>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data [class]="'wide-container'" *ngIf="!data.length && !loading"></app-no-widget-data>

